// Estimate Engine (PROTOTYPE) — nested routes.
// Mounted in src/app/App.jsx:
//   /swiftboard/estimates/*        → <EstimateRoutes />
//   /swiftboard/estimate-settings/* → <EstimateSettingsRoutes />
import { Navigate, Route, Routes } from "react-router-dom";
import NotFound from "../not-found/page";
import EstimatesList from "./pages/estimates-list/EstimatesList";
import EstimateWizard from "./pages/estimate-wizard/EstimateWizard";
import EstimateWorkspace from "./pages/estimate-workspace/EstimateWorkspace";
import TakeoffTab from "./pages/estimate-workspace/tabs/takeoff/TakeoffTab";
import EquipmentTab from "./pages/estimate-workspace/tabs/EquipmentTab";
import GenConditionsTab from "./pages/estimate-workspace/tabs/GenConditionsTab";
import MaterialListTab from "./pages/estimate-workspace/tabs/MaterialListTab";
import BoqTab from "./pages/estimate-workspace/tabs/BoqTab";
import BidFormTab from "./pages/estimate-workspace/tabs/bid-form/BidFormTab";
import HistoryTab from "./pages/estimate-workspace/tabs/HistoryTab";
import EstimateSettings from "./pages/estimate-settings/EstimateSettings";

export function EstimateRoutes() {
  return (
    <Routes>
      <Route index element={<EstimatesList />} />
      <Route path="new/:jobId" element={<EstimateWizard />} />
      <Route path=":estimateId" element={<EstimateWorkspace />}>
        <Route index element={<Navigate to="takeoff" replace />} />
        <Route path="takeoff" element={<TakeoffTab />} />
        <Route path="equipment" element={<EquipmentTab />} />
        <Route path="gen-conditions" element={<GenConditionsTab />} />
        <Route path="materials" element={<MaterialListTab />} />
        <Route path="boq" element={<BoqTab />} />
        <Route path="bid" element={<BidFormTab />} />
        <Route path="history" element={<HistoryTab />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export function EstimateSettingsRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="global" replace />} />
      <Route path=":section" element={<EstimateSettings />} />
    </Routes>
  );
}
